import { z } from 'zod';

export const schemaConsorsPlaceOfIssue = z
    .string()
    .min(0)
    .max(15)
    .regex(/^[^<>?!#$%^]*$/, 'Invalid characters');
